import { ChevronsDownUp, ChevronsUpDown } from "@baton/icons";

/**
 * Expand all and Collapse all over a run of collapsible headings (the owner's requests of
 * 2026-09-30, `contracts/screens.md` § 020 Accounts and pipeline): the Regions label of the Clients
 * sidebar, and the client list's toolbar over its grouping rows or the client board's columns. It is
 * one control whose state follows the headings as they are: Collapse all while any of them is open,
 * Expand all once every one is collapsed. A heading with no entry in the collapsed record is open.
 */
export type Collapsed = Readonly<Record<string, boolean>>;

/** Whether any of the headings is open, which makes the control Collapse all. */
export function anyOpen(ids: readonly string[], collapsed: Collapsed): boolean {
  return ids.some((id) => !(collapsed[id] ?? false));
}

/** The record with every one of the headings collapsed, or every one open; entries of headings not drawn now are kept. */
export function withEvery(collapsed: Collapsed, ids: readonly string[], value: boolean): Collapsed {
  return { ...collapsed, ...Object.fromEntries(ids.map((id) => [id, value])) };
}

/** The control's glyph: the chevrons drawing together to collapse, apart to expand. */
export function CollapseAllGlyph({ open }: { readonly open: boolean }) {
  return open ? <ChevronsDownUp /> : <ChevronsUpDown />;
}
